export default __webpack_public_path__ + "static/media/m-pesa-logo-green-and-red.c0e3cef2.png";